import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        isNotLogin: false,
        isEffect: false,
        count: 0,
        unReadBbsCount: 0,
        unReadMsgListCount: 0,
        unReadSiteMsgCount: 0,
        isMobile: false
    },
    getters: {},
    mutations: {
        setUnReadBbsCount(state, value) {
            state.unReadBbsCount = value;
        },
        setUnReadMsgListCount(state, value) {
            state.unReadMsgListCount = value;
        },
        setUnReadSiteMsgCount(state, value) {
            state.unReadSiteMsgCount = value;
        },
        getUserInfo(state) {
            let s = new Promise((resolve, reject) => {
                Axios.get('vul/hsrc/vul/report/services/user/getUserInfo')
                    .then(res => {
                        if (res.data && res.data.status === 200) {
                            // Vue.prototype.$bus.$emit('send', res.data.data.unReadSiteMsgCount);
                            state.isNotLogin = false;
                            resolve(true);
                        } else {
                            state.isNotLogin = true;
                            resolve(false);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response && error.response.data && error.response.data.code === 'hihonor.account.00010010') {
                            state.isEffect = true;
                            state.isNotLogin = true;
                        }
                        reject(error);
                    });
            });
        },
        add(state) {
            state.count++;
        },
        setIsMobile(state, val) {
            state.isMobile = val;
        }
    },
    actions: {
        getUserInfoAsync(state) {
            state.commit('getUserInfo');
        },
        adds(state) {
            state.commit('add');
        }
    }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js